import { forwardRef } from "react";

interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = "", label, ...props }, ref) => {
    return (
      <div className="space-y-1">
        {label && (
          <label className="text-sm font-semibold text-gray-700">{label}</label>
        )}
        <textarea
          ref={ref}
          className={`w-full rounded-[8px] border border-[#dbdbdb] bg-white px-3 py-2 text-sm placeholder:text-[#706f6f] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#e07828] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
          {...props}
        />
      </div>
    );
  }
);

Textarea.displayName = "Textarea";
